import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { BeamlineStatusCreate, BeamlineStatusDelete, BeamlineStatusRefresh, BeamlineStatusUpdate } from './bl-status.action';
import { BeamlineServService } from '../beamline-serv.service';
import { BeamlineStatus } from '../beamline-status';
import { readStatusSnapshot, writeStatusSnapshot } from '../../status-snapshot-cache';

const BEAMLINE_STATUS_SNAPSHOT_KEY = 'home:beamline-status:snapshot';

export class BeamlineStatusStateModel {
  data!: BeamlineStatus[];
  loading!: boolean;
  // Cached values do not mark the live startup refresh complete.
  loaded!: boolean;
}

@State<BeamlineStatusStateModel>({
  name: 'BeamlineStatus',
  defaults: {
    data: [],
    loading: false,
    loaded: false,
  }
})

@Injectable()
export class BeamlineStatusState extends BaseState {
  constructor(
    protected override injector: Injector,
    private _service: BeamlineServService
  ) {
    super(injector);
  }

  @Selector()
  static read(state: BeamlineStatusStateModel) {
    return state.data;
  }

  @Action(BeamlineStatusRefresh)
  refresh({ getState, patchState }: StateContext<BeamlineStatusStateModel>) {
    patchState({ loading: true, loaded: false });

    if (!getState().data?.length) {
      const snapshot = readStatusSnapshot<BeamlineStatus[]>(BEAMLINE_STATUS_SNAPSHOT_KEY);
      if (snapshot?.length) patchState({ data: snapshot });
    }

    this._service.getBeamlineStatus().subscribe(
      data => {
        patchState({ data, loading: false, loaded: true });
        writeStatusSnapshot(BEAMLINE_STATUS_SNAPSHOT_KEY, data);
      },
      error => {
        patchState({ loading: false });
        console.error(error);
      }
    );
  }

  @Action(BeamlineStatusCreate)
  create({ getState, patchState }: StateContext<BeamlineStatusStateModel>, { item }: BeamlineStatusCreate) {
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(BeamlineStatusUpdate)
  update({ getState, patchState }: StateContext<BeamlineStatusStateModel>, { id, item }: BeamlineStatusUpdate) {
    const state = getState();
    const index = state.data.map(x => x.beamlineId).indexOf(id);

    if (index >= 0) {
      state.data.splice(index, 1);
      patchState({
        data: [...state.data, item]
      });
    }
  }

  @Action(BeamlineStatusDelete)
  delete({ getState, patchState }: StateContext<BeamlineStatusStateModel>, { id }: BeamlineStatusDelete) {
    patchState({
      data: getState().data.filter(x => x.beamlineId != id)
    });
  }

}
